import React from 'react';
import './index.less';
import classnames from 'classnames';
import DatePicker from '../../';
import { IDateRangePickerProps } from '../../interface';
import RangePickerHelper from '../../helper/rangePickerHelper';

class DateRangePicker extends React.Component<IDateRangePickerProps> {
  private pickerHelper: RangePickerHelper = new RangePickerHelper();

  static defaultProps() {
    return {
      startPlaceholder: '起',
      endPlaceholder: '止',
      size: 'default',
      fontSize: 'default'
    };
  }

  constructor(props: IDateRangePickerProps) {
    super(props);
    this.pickerHelper.init(props);
  }

  componentDidUpdate() {
    this.pickerHelper.init(this.props);
  }

  render() {
    const {
      size,
      fontSize,
      desc,
      startValue,
      endValue,
      startDefaultValue,
      endDefaultValue,
      startPlaceholder,
      endPlaceholder,
      removeMarginBottom,
      isVertical,
      startRules,
      endRules,
      isFlex
    } = this.props;
    const { title, required, labelWidth, removePaddingLeft, contentWidth } = this.props;
    const titleProps = { title, required, labelWidth, removePaddingLeft };

    const classes = classnames(
      'abs-range-date-picker',
      { 'abs-range-date-picker-large': size === 'large' },
      { 'abs-range-date-picker-font-s': fontSize === 'small' },
      { 'remove-margin-bottom': removeMarginBottom },
      { 'title-vertical': isVertical }
    );

    const dropdownClasses = classnames({
      'abs-range-date-picker-dropdown-large': size === 'large'
    });

    return (
      <div className={classes}>
        <DatePicker
          ref={view => (this.pickerHelper.startPickerRef = view)}
          dropdownClassName={dropdownClasses}
          {...titleProps}
          desc={desc}
          requiredMsg="请选择开始日期"
          value={startValue}
          placeholder={startPlaceholder}
          defaultValue={startDefaultValue}
          removeMarginBottom={true}
          rules={startRules}
          disabledDate={this.pickerHelper.renderDisabledStart}
          onChange={this.onStartChange}
          contentWidth={contentWidth}
          isFlex={isFlex}
        />
        <div className="abs-range-date-picker-split" />
        <DatePicker
          ref={view => (this.pickerHelper.endPickerRef = view)}
          dropdownClassName={dropdownClasses}
          required={required}
          requiredMsg="请选择截止日期"
          value={endValue}
          placeholder={endPlaceholder}
          defaultValue={endDefaultValue}
          removeMarginBottom={true}
          rules={endRules}
          disabledDate={this.pickerHelper.renderDisabledEnd}
          onChange={this.onEndChange}
          contentWidth={contentWidth}
          isFlex={isFlex}
        />
      </div>
    );
  }

  onStartChange = (date, dateString) => {
    const { onStartChange } = this.props;
    this.pickerHelper.onStartChange(date, dateString, onStartChange);
  };

  onEndChange = (date, dateString) => {
    const { onEndChange } = this.props;
    this.pickerHelper.onEndChange(date, dateString, onEndChange);
  };

  /**
   * 验证
   */
  validatorValue = () => this.pickerHelper.validatorValue();

  reset = () => this.pickerHelper.reset(this.props);

  getValue = () => this.pickerHelper.getValue();
}

export { IDateRangePickerProps };

export default DateRangePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/RangePicker/DateRangePicker/index.tsx